import api from './api';
import type { RawRole } from './profile';

export type LoginPayload = { email: string; password: string };
export type RegisterPayload = {
  name: string;
  email: string;
  phone: string;
  password: string;
  password_confirmation: string;
};

type AuthResponse = {
  token: string;
  name: string;
  email: string;
  phone?: string | null;
  role?: RawRole;
  role_id?: RawRole;
  roleId?: RawRole;
};

export async function login(payload: LoginPayload) {
  const { data } = await api.post('auth/login', payload);
  return data as AuthResponse;
}

export async function register(payload: RegisterPayload) {
  const { data } = await api.post('auth/register', payload);
  return data as AuthResponse;
}

export async function forgotPassword(email: string) {
  const { data } = await api.post('auth/forgot-password', { email });
  return data as { status: string };
}

export async function resetPassword(token: string, email: string, password: string, password_confirmation: string) {
  const { data } = await api.post('auth/reset-password', {
    token,
    email,
    password,
    password_confirmation,
  });
  return data as { status: string };
}

export async function changePassword(current_password: string, password: string, password_confirmation: string) {
  const { data } = await api.post('auth/change-password', {
    current_password,
    password,
    password_confirmation,
  });
  return data as { status: string };
}
